import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderTireAxlesAdapter = getAdapter({ idFieldName: 'value' });

const repairOrderTireAxlesSlice = createSlice({
  name: 'repairOrderTireAxles',
  initialState: repairOrderTireAxlesAdapter.getInitialState(),
  reducers: {
    setRepairOrderTireAxles: (state, { payload: { repairOrderTireAxles } }) => {
      repairOrderTireAxlesAdapter.setAll(state, repairOrderTireAxles);
    },
  },
});

const selectors = repairOrderTireAxlesAdapter.getSelectors(
  ({ repairOrderTireAxles }) => repairOrderTireAxles,
);

export const getRepairOrderTireAxles = (state) => selectors.selectAll(state);

export const { setRepairOrderTireAxles } = repairOrderTireAxlesSlice.actions;

export default repairOrderTireAxlesSlice.reducer;
